module.exports = __webpack_public_path__ + "img/image121.5f6b548f.jpg";